export const PATIENT_DETAIL_KEY = {
  PATIENT_INFORMATION: 'Patient information',
  PATIENT_CONTACT: 'Patient contact',
  SECONDARY_CONTACT: 'Secondary contact',
  INSURANCE: 'Insurance',
  MEDICAL_HISTORY: 'Medical history',
};
export const a = '';
